import * as net from 'util/Net';

import {RequestTask, ServerRequestTask, ServerUIRequestTask} from './RequestTaskConstants';

interface ListRequestTasksResponse {
  requestTasks: Array<RequestTask>;
  sampleGroupIdsByRequestTaskId: {[taskId: string]: Array<string>};
}

export function listRequestTasks(requestIds: Array<string>): Promise<ListRequestTasksResponse> {
  return net.postJSONPromise({url: `/1/api/request-tasks:bulk-get`, data: {requestIds}});
}

interface CreateRequestTasksResponse {
  requestTask: RequestTask;
  requestTaskIdsByRequestId: {[requestId: string]: Array<string>};
}

export function createRequestTask(
  requestId: string,
  requestTask: ServerUIRequestTask
): Promise<CreateRequestTasksResponse> {
  return net.postJSONPromise({url: `/1/api/requests/${requestId}/request-tasks`, data: requestTask});
}

interface UpdateRequestTaskResponse {
  requestTask: RequestTask;
}

export function updateRequestTask(newRequestTask: ServerRequestTask): Promise<UpdateRequestTaskResponse> {
  return net.patchJSONPromise({
    url: `/1/api/request-tasks/${newRequestTask.id}`,
    data: newRequestTask,
  });
}

export function deleteRequestTask(requestTaskId: string): Promise<{}> {
  return net.deletePromise({url: `/1/api/request-tasks/${requestTaskId}`});
}
